<template>
  <div class="mt-4">
    <!-- {{ mailingList }} -->
    <div class="row">
      <div class="col-lg-12"v-for="email in mailingList" :key="email.id">
        <p v-if="email.category == ''">{{ email.email }}</p>
      </div>
      <hr>
      <div class="col-lg-6">
        <h3>Employers</h3>
        <div v-for="email in mailingList" :key="email.id">
          <p v-if="email.category == 'Employer'">{{ email.email }}</p>
        </div>
      </div>
      <div class="col-lg-6">
        <h3>Candidates</h3>
        <div v-for="email in mailingList" :key="email.id">
          <p v-if="email.category == 'Candidate'">{{ email.email }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      mailingList: [],
    }
  },
  created() {
    this.getMailingList()
  },
  methods: {
    getMailingList() {
      axios.get('/api/mailinglist/?agency='+this.$store.getters.agencyID.toString())
        .then(res => {
          console.log(res)
          this.mailingList = res.data
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/MailingList.vue